import { useEffect } from 'react';
import { useStore } from 'react-redux';
import { ensurePrintingLogo } from '@makemydeal/dr-dash-store/services/ensurePrintingLogo';
import type { StateTree } from '@makemydeal/dr-dash-types';

/**
 * Loads the dealer printing logo for components that *display* it (Dealer Logo Upload) rather than
 * on page initialization.
 *
 * Print flows must NOT rely on this hook — they call `ensurePrintingLogo` from the middleware or
 * service that builds the payload, so a print can never race ahead of the fetch.
 */
export const useFetchPrintingLogo = (): void => {
    const store = useStore<StateTree>();

    useEffect(() => {
        void ensurePrintingLogo(store);
    }, [store]);
};
